import { swRequest } from "./sw-request";

export const addManualToDo = (body) =>
  swRequest({
    path: "/api/todos/add_manual",
    method: "POST",
    body,
  });

export const assignToDoContact = (body) =>
  swRequest({
    path: "/api/todos/assign_contact",
    method: "POST",
    body,
  });

export const delayTodos = (body) =>
  swRequest({
    path: "/api/todos/delay",
    method: "POST",
    body,
  });

export const saveTodosStatus = (body) =>
  swRequest({
    path: "/api/todos/save_status",
    method: "POST",
    body,
  });

export const queryTodos = (body, opts = {}) =>
  swRequest(
    {
      path: "/api/todos/query",
      method: "POST",
      body,
    },
    opts,
  );

/** Convert inMails to emails. Also used for Approve email step. */
export const sendEmail = (body) =>
  swRequest({
    path: "/api/todos/send_email",
    method: "POST",
    body,
  });

export const tryNewEmail = (body) =>
  swRequest({
    path: "/api/todos/try_new_email",
    method: "POST",
    body,
  });
